import { useCallback, useEffect } from 'react'

import AnimatedLynkIcon from 'src/features/lynk/components/animated-lynk-icon'

import { useUploadLeadsContext } from '../../context/upload-leads-context'
import { useUploadLeadsStore } from '../../store/upload-leads-store'

export default function LynkStep() {
  const { handleNext, setFooterConfig } = useUploadLeadsContext()
  const setFormData = useUploadLeadsStore((state) => state.setFormData)

  const handleLynkChoice = useCallback(
    (lynkEnabledForFile: boolean) => {
      const { formData } = useUploadLeadsStore.getState()
      setFormData({
        ...formData,
        lynkEnabledForFile,
      })
      handleNext()
    },
    [handleNext, setFormData],
  )

  useEffect(() => {
    setFooterConfig({
      buttonText: 'Turn Lynk on',
      primaryAction: () => handleLynkChoice(true),
      bottomLeftContent: {
        variant: 'link-button',
        text: 'Continue without Lynk',
        onClick: () => handleLynkChoice(false),
      },
    })

    return () => {
      setFooterConfig(null)
    }
  }, [handleLynkChoice, setFooterConfig])

  return (
    <div className="flex size-full items-center px-5">
      <div className="mx-auto w-full max-w-[500px]">
        <div className="flex flex-col items-center">
          <div className="w-full max-w-[460px] text-center">
            <div className="flex items-center justify-center gap-2.5">
              <div className="relative size-[35px]">
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <AnimatedLynkIcon variant="gradient" width={55} height={55} />
                </div>
              </div>
              <h1 className="text-[36px] font-semibold leading-tight tracking-[-0.36px] text-primary">Let Lynk work</h1>
            </div>
            <p className="mt-2.5 text-[18px] font-medium leading-[1.6] text-muted">
              Turn workflows on or off. Lynk handles the rest.
            </p>
          </div>

          {/* Video placeholder */}
          {/* <div className="mt-10 h-[300px] w-full rounded-[30px] bg-accent" /> */}
        </div>
      </div>
    </div>
  )
}
